import { Box } from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import MuiCard from "@mui/material/Card";
import MuiCardContent from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  justify-content: center;
  z-index: 1;
  border-radius: 8px;
  transform: translateY(-50%);
`;

export const ProfileCard = styled(MuiCard)`
  z-index: 2;
  width: 100%;
  border: 1px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  ${(props) => props.theme.breakpoints.up("mobile")} {
    width: 50%;
  }
`;

export const CardContent = styled(MuiCardContent)`
  padding: 14px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Avatar = styled(MuiAvatar)`
  background-color: #a0aec0;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  color: ${(props) => props.theme.text.primary};
  text-align: center;
  font-size: 14px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const UserNameAndProfileTagWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const UserName = styled(Typography)`
  color: ${(props) => props.theme.text.primary};
  font-size: 20px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const ViewProfileTag = styled(Typography)`
  color: #718096;
  font-size: 14px;
  font-family: "NotoSans-Regular";
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const ProfileWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
`;
